import React from 'react'
import { Container, Row } from 'reactstrap'
import UserFirstProfile from '../../../../Utils/CommonComponents/CommonUserProfile/UserFirstProfile'
import Breadcrumbs from '../../../../CommonElements/Breadcrumbs'
import { UserProfileTitle, UsersTitle } from '../../../../Utils/Constants'

export default function UserProfileContainer() {
    return (
        <>
            <Breadcrumbs pageTitle={UserProfileTitle} parent={UsersTitle} title={UserProfileTitle} />
            <Container fluid>
                <div className="user-profile">
                    <Row>
                        <UserFirstProfile />
                     
                    </Row>
                </div>
            </Container>
        </>
    )
}